import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { createSvgIcon } from '@pets-ui/Icons/createSvgIcon'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom-v5'
import BarcodeReadSvg from '../../assets/barcode-read.svg?react'
import { useApiCampaignIsAdmin } from '../../hooks/apis/use-api-campaign-is-admin'

const BarcodeRead = createSvgIcon(BarcodeReadSvg)

export const AppBarAdminScan = () => {
  const { t } = useTranslation()
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: campaignMember } = useApiCampaignMember({ code: campaignCodeFromUrl })
  const { destructuredData: campaignAdmin } = useApiCampaignIsAdmin(campaignMember ? campaignCodeFromUrl : null)

  if (!campaignAdmin?.is_admin) return null

  return (
    <IconButton component={Link} to={`/admin/${campaignCodeFromUrl}/admin-scan`} aria-label={t('qrcode.scan', { defaultValue: '掃描客人 QR Code' }) || ''} width="32px" height="32px">
      <BarcodeRead color={colors.grey900} />
    </IconButton>
  )
}
